export default "__VITE_ASSET__bb4cd0c0__"